import {
  type DemandeStore,
  type PrintAction,
  buildPrintDemandeWithTemplate,
  useDemandePrint,
} from '@/features/interface/demande/shared'

export function useFormationDemandeCXPIPrint(store: DemandeStore<'MODEL_CXPI'>) {
  const actionPrintContrat: PrintAction = {
    mustSave: true,
    label: 'Générer le Contrat',
    jobs: buildPrintDemandeWithTemplate<'MODEL_CXPI'>({
      store,
      typeDocumentTemplate: 'ContratCxpi',
      filenameKeys: ['dispositif', 'id'],
    }),
  }

  const actionPrintLettreMission: PrintAction = {
    mustSave: true,
    label: 'Générer la lettre de mission',
    jobs: buildPrintDemandeWithTemplate<'MODEL_CXPI'>({
      store,
      typeDocumentTemplate: 'MissionCxpi',
      filenameKeys: ['dispositif', 'id'],
    }),
  }

  return useDemandePrint<'MODEL_CXPI'>({
    store,
    getActions: () =>
      store.model?.contrat?.cdiInterimaire === true
        ? [actionPrintLettreMission]
        : [actionPrintContrat],
  })
}
